import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

class FormCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: !!this.props.defaultValue,
      formData: this.props.defaultValue,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.setState({
        formData: this.props.defaultValue,
        showForm: !!this.props.defaultValue,
      });
    }
  }

  render() {
    return (
      <div>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={this.state.showForm}
              disabled={this.props.disabled}
              onChange={(event, isInputChecked) => {
                this.setState({ showForm: isInputChecked });
                if (!isInputChecked) {
                  this.setState({ formData: '' });
                }
                this.props.input.onChange('');
              }}
            />
          }
          label={this.props.checkboxLabel}
        />

        <TextField
          value={this.state.formData || ''}
          disabled={this.props.disabled || !this.state.showForm}
          error={!!(this.props.meta.dirty && this.props.meta.error)}
          fullWidth
          onChange={(event) => {
            this.setState({ formData: event.target.value });
            this.props.input.onChange(event.target.value);
          }}
          label={this.props.label}
          helperText={this.props.helperText}
        />
      </div>
    );
  }
}

FormCheckbox.propTypes = {
  meta: PropTypes.object,
  input: PropTypes.object,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  checkboxLabel: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
};

export default FormCheckbox;
